<template>
    <div id="cam_setup">
        <v-card class="tab_card">
            <v-card-title>
              <span class="main_card_title">
                {{ $i18n.t('pages.devices.cameras.cameras_settings') }}
              </span>
            </v-card-title>
            <v-card-text>
                <v-data-table
                  dense
                  :headers="cam_datatable_headers"
                  :items="cams_data"
                  :loading="cams_table_loading"
                  :loading-text="$i18n.t('general.loading')"
                  :footer-props="{
                    itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                    itemsPerPageOptions: [10, 20, 30, 50],
                  }"
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:body="{items}">
                    <tbody>
                      <tr v-for="cam in items" :key="cam._id['$oid']">
                        <td>{{cam.name}}</td>
                        <td>{{cam_gate_and_checkpoint_names(cam).gate_name}}</td>
                        <td>{{cam_gate_and_checkpoint_names(cam).checkpoint_name}}</td>
                        <td>{{cam.rtsp_link}}</td>
                        <td>{{ $i18n.t(`general.direction_${cam.view_direction}`) }}</td>
                        <td>
                          <div style="display: flex; justify-content: flex-end">
                            <v-btn icon @click="open_cam_editor(cam)"><v-icon>$icon_edit</v-icon></v-btn>
                            <v-btn icon @click="delete_cam(cam)"><v-icon>$icon_trash</v-icon></v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
            </v-card-text>

        </v-card>

      <v-dialog eager
        v-model="cam_edit_dialog"
        :max-width="stepper_card_width"
      >
          <v-card style="border-radius: 8px">
              <v-card-title>
                  <span>{{form_title}}</span>
              </v-card-title>
              <v-stepper v-model="step" non-linear>
                  <v-stepper-items>
                      <v-stepper-content step="1" style="padding: 0 0 0 0">
                          <v-card-text style="padding: 0 15px 30px">
                             <v-form class="edit_card_container" id="form_step_one" v-model="validation.first_step" ref="first_step_valid">
                               <v-subheader class="subheader">{{ $i18n.t('pages.devices.cameras.dialog.cam_name') }}</v-subheader>
                               <v-text-field
                                   outlined
                                   :placeholder="$i18n.t('pages.devices.cameras.dialog.cam_name')"
                                   v-model="edited_cam.name"
                                   :rules="validation.rules.cam_name"
                                   class="rounded_8px height-textfield"
                                />
                               <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.view_direction') }}</v-subheader>
                                <v-select
                                  ref="cam-direction"
                                  v-model="edited_cam.view_direction"
                                  :items="direction_types"
                                  :rules="validation.rules.direction"
                                  :placeholder="$i18n.t('pages.devices.cameras.dialog.view_direction')"
                                  outlined
                                  class="rounded_8px height-textfield"
                                />
                               <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.checkpoint') }}</v-subheader>
                                <v-select
                                  outlined
                                  :placeholder="$i18n.t('pages.devices.cameras.dialog.checkpoint')"
                                  :items="checkpoints"
                                  item-text="name"
                                  item-value="_id"
                                  v-model="selected_checkpoint_id"
                                  class="rounded_8px height-textfield"
                                >
                                  <template v-slot:selection="data">
                                      {{data.item.name}}
                                  </template>
                                </v-select>
                               <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.gate') }}</v-subheader>
                                <v-select
                                  outlined
                                  :placeholder="$i18n.t('pages.devices.cameras.dialog.gate')"
                                  v-model="edited_cam.gate_id"
                                  :items="gates_in_selected_checkpoint"
                                  item-text="name"
                                  item-value="_id"
                                  class="rounded_8px height-textfield"
                                >
                                  <template v-slot:selection="data">
                                      {{data.item.name}}
                                  </template>
                                </v-select>

                               <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.rtsp_link') }}</v-subheader>
                               <v-text-field
                                 outlined
                                 :placeholder="$i18n.t('pages.devices.cameras.dialog.rtsp_link')"
                                 v-model="edited_cam.rtsp_link"
                                 :rules="validation.rules.rtsp_link"
                                 v-on:focusout="ip_from_rtsp_link();username_from_rtsp_link();password_from_rtsp_link();"
                                 class="rounded_8px height-textfield"
                               />
                               <v-list-item-action class="cam_settings_action_width">
                                    <v-checkbox
                                        v-model="edited_cam.cross_line_detection"
                                        :label="cross_line_detection_state_str"
                                    />
                               </v-list-item-action>
                               <v-subheader v-if = edited_cam.cross_line_detection class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.ip_address') }}</v-subheader>
                                <v-text-field
                                 v-if = edited_cam.cross_line_detection
                                 outlined
                                 :placeholder="$i18n.t('pages.devices.cameras.dialog.ip_address')"
                                 v-model="edited_cam.ip_address"
                                 :rules="rules"
                                 class="rounded_8px height-textfield"
                               />
                               <v-subheader v-if = edited_cam.cross_line_detection class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.port') }}</v-subheader>
                               <v-text-field
                                 v-if = edited_cam.cross_line_detection
                                 outlined
                                 :placeholder="$i18n.t('pages.devices.cameras.dialog.port')"
                                 v-model="edited_cam.port"
                                 :rules="rules"
                                 class="rounded_8px height-textfield"
                               />
                               <v-subheader v-if = edited_cam.cross_line_detection class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.username') }}</v-subheader>
                                <v-text-field
                                 v-if = edited_cam.cross_line_detection
                                 outlined
                                 :placeholder="$i18n.t('pages.devices.cameras.dialog.username')"
                                 v-model="edited_cam.username"
                                 :rules="rules"
                                 class="rounded_8px height-textfield"
                               />
                               <v-subheader v-if = edited_cam.cross_line_detection class="subheader margin-t">{{ $i18n.t('pages.devices.cameras.dialog.password') }}</v-subheader>
                                <v-text-field
                                 v-if = edited_cam.cross_line_detection
                                 outlined
                                 :placeholder="$i18n.t('pages.devices.cameras.dialog.password')"
                                 v-model="edited_cam.password"
                                 :rules="rules"
                                 class="rounded_8px height-textfield"
                               />
                               <div class="cams_step_one_buttons">
                                 <v-btn
                                   color="#DBEAF1"
                                   height="42"
                                   elevation="0"
                                   class="white--text exit-button"
                                   @click="close_editor"
                                 >
                                   <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                                 </v-btn>
                                 <v-btn
                                   color="#207ea9"
                                   height="42"
                                   elevation="0"
                                   class="white--text save-button"
                                   @click="edit_step_two"
                                 >
                                   <span class="button-font">{{ $i18n.t('general.next_step') }}</span>
                                 </v-btn>
                               </div>
                             </v-form>
                          </v-card-text>
                      </v-stepper-content>

                      <v-stepper-content step="2" style="padding: 0 0 0 0">
                        <v-card-text style="display: flex; flex-wrap: wrap; justify-content: center; padding: 0 15px 30px;">
                          <v-form
                              class="edit_card_container"
                              :style="{ width: image_params.view_w + 'px'}"
                              v-model="validation.second_step"
                              ref="second_step_valid"
                          >
                            <div class="outside-wrapper" :style="{ width: image_params.view_w + 'px', height: image_params.view_h + 'px'}">
                                <div class="inside-wrapper">
                                    <div class="loading-circular" v-if="!image.src">
                                      <v-progress-circular
                                        :size="70"
                                        color="primary"
                                        indeterminate
                                      />
                                    </div>
                                    <canvas
                                        id="covering_canvas"
                                        class="covered-image"
                                        :width="image_params.view_w"
                                        :height="image_params.view_h"
                                    />
                                    <canvas id="drawing_canvas"
                                        :width="image_params.view_w"
                                        :height="image_params.view_h"
                                        class="drawing-canvas"
                                        @mousemove="drawing($event)"
                                        @mousedown="start_finish_drawing($event)"
                                    />
                                </div>
                            </div>
                            <div style="display: flex; justify-content: space-between; margin-top: 15px ">
                            <v-radio-group v-model="selected_area" style="width: 300px">
                              <!--<v-radio style="margin-bottom: 5px" value="both_detect" :label="areas_checkbox_title('both_detect')"/> -->
                              <v-radio
                                  style="margin-bottom: 5px"
                                  value="plates_detect"
                                  color="#207EA9"
                                  :label="areas_checkbox_title('plates_detect')"/>
                              <v-radio
                                  style="margin-bottom: 5px"
                                  value="motion_detect"
                                  color="#207EA9"
                                  :label="areas_checkbox_title('motion_detect')"/>
                              </v-radio-group>
                              <div>
                                 <v-toolbar
                                    v-if="this.edited_cam.cross_line_detection"
                                    color="#207EA9"
                                    style="height: 50px; justify-content: center; align-content: center"
                                    dark
                              >
                               <v-toolbar-title style="align-self: center">Доступные линии</v-toolbar-title>
                               <v-spacer></v-spacer>
                               <v-btn icon @click="add_line()">
                                 <v-icon>
                                   mdi-plus
                                 </v-icon>
                               </v-btn>
                              </v-toolbar>
                              <v-list style="height:100px;overflow-y:auto" v-if="this.edited_cam.cross_line_detection">
                                <v-list-item
                                  v-for="(item, i) in cam_lines"
                                  :key="i"
                                >
                                <v-list-item-action>
                                  <v-checkbox
                                    v-model="selected_lines"
                                    color="deep-purple accent-4"
                                    value="item.text"
                                  ></v-checkbox>
                                </v-list-item-action>
                                  <v-list-item-content>
<!--                                    <v-list-item-title v-text="item.text"></v-list-item-title>-->
                                    <v-text-field
                                        :readonly="!is_line_readonly(i)"
                                        :append-icon="is_line_readonly(i) ? 'mdi-check' : ''"
                                        v-model="item.name"
                                        style="width: 100px"
                                        @click:append="finish_edit_line(i)"
                                        @input="open_line_editor(item.name, i)"

                                 ></v-text-field>
                                  </v-list-item-content>

                                  <v-btn @click="add_arrow_left(item.name)" icon color="#207EA9" :disabled="!is_line_readonly(i)">
                                    <v-icon >
                                    mdi-arrow-left
                                    </v-icon>
                                  </v-btn>
                                  <v-btn @click="add_arrow_right(item.name)" :disabled="!is_line_readonly(i)" icon color="#207EA9">
                                    <v-icon>
                                      mdi-arrow-right
                                    </v-icon>
                                  </v-btn>
                                  <v-btn icon @click="open_line_editor(item.name, i)"><v-icon>$icon_edit</v-icon></v-btn>
                                  <v-btn icon @click="delete_line(item.name, i)"><v-icon>$icon_trash</v-icon></v-btn>
                                </v-list-item>
                            </v-list>
                            </div>

                            </div>
                            <div class="cams_step_one_buttons">
                              <v-btn
                                  color="#DBEAF1"
                                  height="42"
                                  elevation="0"
                                  class="white--text exit-button"
                                  dark @click="edit_step_one"
                              >
                                <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.back') }}</span>
                              </v-btn>
                              <v-btn
                                  color="#207ea9"
                                  height="42"
                                  elevation="0"
                                  class="white--text save-button"
                                  @click="edit_step_three"
                              >
                                <span class="button-font">{{ $i18n.t('general.next_step') }}</span>
                              </v-btn>
                            </div>
                          </v-form>
                        </v-card-text>
                      </v-stepper-content>

                      <v-stepper-content step="3" style="padding: 0 0 0 0">
                        <v-card-text style="padding: 0 25px 30px">
                              <v-list>
                                <v-list-item>
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.motion_detection') }}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-checkbox
                                        v-model="edited_cam.motion_detection"
                                        :label="motion_detection_state_str"
                                    />
                                  </v-list-item-action>
                                </v-list-item>
                                <v-list-item :disabled="!edited_cam.motion_detection">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.motion_detection_sensitivity')}}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-slider
                                        height="35px"
                                        class="slider"
                                        thumb-label
                                        thumb-size="20"
                                        :min="advanced_settings_range.diff_rate.min"
                                        :max="advanced_settings_range.diff_rate.max"
                                        v-model="edited_cam.diff_rate"
                                        :disabled="!edited_cam.motion_detection"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="!edited_cam.motion_detection">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.min_relative_object_size')}}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-slider
                                        height="35px"
                                        class="slider"
                                        thumb-label
                                        thumb-size="20"
                                        :min="advanced_settings_range.min_relative_obj_size.min"
                                        :max="advanced_settings_range.min_relative_obj_size.max"
                                        v-model="edited_cam.min_relative_obj_size"
                                        :disabled="!edited_cam.motion_detection"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="!edited_cam.motion_detection">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.motion_detection_rate')}}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-slider
                                        style="width: 550px"
                                        thumb-label
                                        thumb-size="20"
                                        :min="motion_detection_rate_range.min"
                                        :max="motion_detection_rate_range.max"
                                        v-model="edited_cam.motion_detection_rate"
                                        :disabled="!edited_cam.motion_detection"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-if=edited_cam.cross_line_detection style="margin-top: 10px">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.first_line_recognize') }}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                  <v-select
                                    v-if="this.cam_lines"
                                    multiple
                                    chips
                                    small-chips
                                    outlined
                                    :placeholder="$i18n.t('pages.devices.cameras.dialog.first_line_recognize')"
                                    v-model="edited_cam.first_line"
                                    :items="lines_in_cam"
                                    item-text="name"
                                    item-value="name"
                                    class="rounded_8px height-textfield"
                                  >
                                  <template v-slot:selection="data">
                                      {{data.item.name}}
                                  </template>
                                </v-select>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-list-item v-if=edited_cam.cross_line_detection style="margin-top: 10px">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.second_line_name') }}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                  <v-select
                                    v-model="edited_cam.second_line"
                                    v-if="this.cam_lines"
                                    multiple
                                    chips
                                    small-chips
                                    outlined
                                    :placeholder="$i18n.t('pages.devices.cameras.dialog.second_line_name')"
                                    :items="lines_in_cam"
                                    item-text="name"
                                    item-value="name"
                                    class="rounded_8px"
                                  >
                                  <template v-slot:selection="data">
                                      {{data.item.name}}
                                  </template>
                                </v-select>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-if=edited_cam.cross_line_detection>
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.cross_line_timeout') }}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-checkbox
                                        v-model="edited_cam.cross_line_timeout_enabled"
                                        :label="cross_line_timeout_str"
                                    />
                                  </v-list-item-action>
                                </v-list-item>
                                <v-list-item v-if=edited_cam.cross_line_detection :disabled="!edited_cam.cross_line_timeout_enabled">
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.cross_line_timeout')}}
                                  </v-list-item-title>
                                  <v-list-item-action  class="cam_settings_action_width">
                                    <v-slider
                                        :disabled="!edited_cam.cross_line_timeout_enabled"
                                        style="width: 550px"
                                        thumb-label
                                        thumb-size="20"
                                        :min="1"
                                        :max="100"
                                        v-model="edited_cam.cross_line_timeout"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.detection_frames_per_second')}}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-slider
                                        style="width: 550px"
                                        thumb-label
                                        thumb-size="20"
                                        :min="advanced_settings_range.frame_rate.min"
                                        :max="advanced_settings_range.frame_rate.max"
                                        v-model="edited_cam.frame_rate"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                  <v-list-item-title>
                                    {{ $i18n.t('pages.devices.cameras.dialog.acceptable_detection_confidence')}}
                                  </v-list-item-title>
                                  <v-list-item-action class="cam_settings_action_width">
                                    <v-slider
                                        style="width: 550px"
                                        thumb-label
                                        thumb-size="20"
                                        :min="advanced_settings_range.acceptable_confidence.min"
                                        :max="advanced_settings_range.acceptable_confidence.max"
                                        v-model="edited_cam.acceptable_confidence"
                                    >
                                    </v-slider>
                                  </v-list-item-action>
                                </v-list-item>
                              </v-list>
                              <div class="cams_step_one_buttons">
                                <v-btn
                                   color="#DBEAF1"
                                   height="42"
                                   elevation="0"
                                   class="white--text exit-button"
                                    @click="edit_step_two"
                                >
                                  <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.back') }}</span></v-btn>
                                <v-btn
                                   color="#207ea9"
                                   height="42"
                                   elevation="0"
                                   class="white--text save-button"
                                   @click="save_cam"
                                >
                                  <span class="button-font">{{ $i18n.t('general.save') }}</span>
                                </v-btn>
                              </div>
                        </v-card-text>
                    </v-stepper-content>
                  </v-stepper-items>
              </v-stepper>

          </v-card>
      </v-dialog>
    </div>
</template>

<script>
import {EventBus} from "@/bus";
import {mapActions} from "vuex";
import {i18n} from "@/i18n";
import {common_funcs} from "@/mixins/common"

export default {
    name: "CameraSetup",
    props: ['on', 'attrs', 'checkpoints', 'gates', 'cams_data', 'cams_table_loading'],
    mixins: [common_funcs],
    data: function () {
        EventBus.$on('ws_on_message', this.ws_on_message)
        EventBus.$on('cameras_event', this.on_cameras_event)
        // this.fetch_data()
        return {
          items: [
        {
          icon: 'mdi-wifi',
          text: 'Wifi',
        },
        {
          icon: 'mdi-bluetooth',
          text: 'Bluetooth',
        },
        {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
        {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
               {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
               {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
               {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
               {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
               {
          icon: 'mdi-chart-donut',
          text: 'Data Usage',
        },
      ],

          selected_lines: [],
          cam_lines: [],
          cam_edit_dialog: false,
          step: 1,
          small_window: '420px',
          big_window: '790px',
          stepper_card_width: '420px',
          edited_cam_index: -1,
          edited_line: '',
          validation: {
            first_step: true,
            second_step: true,
            rules: {
              cam_name: [
                v => !!v || i18n.t('validation.this_field_is_required'),
              ],
              direction: [
                v => !!v || i18n.t('validation.this_field_is_required'),
              ],
              rtsp_link: [
                v => !!v || i18n.t('validation.this_field_is_required'),
              ]
            }
          },
          image: '',
          image_params: {
            real_h: '',
            real_w: '',
            view_h: 405,
            view_w: 720,
            width_lines: 8192,
            height_lines: 8192
          },
          view_interval_id: '',
          default_cam: {
            name: '',
            rtsp_link: '',
            x: null, y: null, w:null, h: null,
            mtn_x: null, mtn_y: null, mtn_w: null, mtn_h: null,
            checkpoint_id: '',
            view_direction: '',
            gate_id: '',
            frame_rate: 3,
            diff_rate: 10,
            min_relative_obj_size: 5,
            motion_detection: true,
            motion_detection_rate: 1,
            acceptable_confidence: 50,
            cross_line_detection: false,
            ip_address: null,
            port: 80,
            username: null,
            password: null,
            first_line: [],
            second_line: [],
            lines: []
          },
          edited_cam: {
            name: '',
            rtsp_link: '',
            plt_x: null, plt_y: null, plt_w:null, plt_h: null,
            mtn_x: null, mtn_y: null, mtn_w: null, mtn_h: null,
            checkpoint_id: '',
            view_direction: '',
            gate_id: '',
            frame_rate: 3,
            diff_rate: 10,
            min_relative_obj_size: 5,
            motion_detection: true,
            motion_detection_rate: 1,
            acceptable_confidence: 50,
            cross_line_detection: false,
            ip_address: null,
            port: 80,
            username: null,
            password: null,
            first_line: [],
            second_line: [],
            lines: {},
            cross_line_timeout_enabled: false,
            cross_line_timeout: null
            // same_plate_detection_delay: 30
          },
          advanced_settings_range: {
            diff_rate: {min: 1, max: 20},
            min_relative_obj_size: {min: 0, max: 10},
            // motion_detection_rate: {min: 1, max: 5}, // Now in computed
            frame_rate: {min: 1, max: 10},
            acceptable_confidence: {min: 1, max: 100}
          },
          cam_datatable_headers: [
              {text: i18n.t('pages.devices.cameras.table.headers.cam_name'), value: 'name', align: 'start'},
              {text: i18n.t('pages.devices.cameras.table.headers.gate'), value: 'gate'},
              {text: i18n.t('pages.devices.cameras.table.headers.checkpoint'), value: 'checkpoint'},
              {text: i18n.t('pages.devices.cameras.table.headers.rtsp_link'), value: 'rtsp_link', sortable: false},
              {text: i18n.t('pages.devices.cameras.table.headers.view_direction'), value: 'view_direction', sortable: false},
              {text: i18n.t('pages.devices.cameras.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
          ],
          selected_checkpoint_id: '',
          cam_name: '',
          cam_view_canvas: null,
          drawing_canvas: null,
          need_to_draw: false,
          // area_types: ['plates_detect'],
          selected_area: 'plates_detect',
          // entry - камера смотрит наружу, в направлении Въезда.
          // exit - камера смотрит внутрь (на территорию), в направлении Выезда
          direction_types: [
            {text: i18n.t('general.direction_entry'), value: 'entry'},
            {text: i18n.t('general.direction_exit'), value: 'exit'},
            ],
          direction_type_readable: {
            'entry': i18n.t('general.direction_entry'),
            'exit': i18n.t('general.direction_exit'),
          }
        }
    },
    methods: {
      ws_on_message: function (message) {
        message = JSON.parse(message)
        let method = message.method
        let params = message.params
          if (method === 'error_handle') {
            this.setSnackbar({
              text: params.message,
            })
          }
          if (method === 'real_img_size') {
            this.set_real_img_size(params)
            this.draw_areas()
          }
          if (method === 'get_cam_lines'){
             this.edited_cam.lines = {}
            this.cam_lines = params.data
            // this.edited_cam.lines = params.data
            for (let line in this.cam_lines){
              this.edited_cam.lines[this.cam_lines[line]["name"]] = {
                "id": this.cam_lines[line]["id"],
                "h": this.cam_lines[line]["h"],
                "x": this.cam_lines[line]["x"],
                "y": this.cam_lines[line]["y"],
                "w": this.cam_lines[line]["w"],
                "visible": true,
                "direction": this.cam_lines[line]["direction"],
                "index": parseInt(line, 10)
              }
            }
            this.draw_areas()
          }
      },
      on_cameras_event: function (params) {
        let event_name = params.event_name
        if (event_name === 'add_camera') {
          this.open_cam_editor(null)
        }
      },
      set_real_img_size: function (params) {
        this.image_params.real_w = params.w
        this.image_params.real_h = params.h
      },
      add_line(){
        this.edited_line = {}
        this.items.push({})
        for(let line in this.edited_cam.lines){
          this.edited_cam.lines[line]["index"] += 1
        }

      },
      draw_areas: function () {
        let lines_color = ['#003db7', '#71e50d', '#f30242', '#9f24e7', '#003db7', '#f1da0d']
        let motion_color = this.selected_area === 'motion_detect' ? '#003db7' : '#bababa'
        let plates_color = this.selected_area === 'plates_detect' ? '#03cb00' : '#bababa'
        this.drawing_canvas.clearRect(0, 0, this.drawing_canvas.canvas.offsetWidth, this.drawing_canvas.canvas.offsetHeight)
        if (this.edited_cam.mtn_x && this.edited_cam.mtn_w) {
          this.draw_rect(motion_color,
            Math.round(this.edited_cam.mtn_x / this.image_width_coeff),
            Math.round(this.edited_cam.mtn_y / this.image_height_coeff),
            Math.round(this.edited_cam.mtn_w / this.image_width_coeff),
            Math.round(this.edited_cam.mtn_h / this.image_height_coeff)
          )
        }
        if (this.edited_cam.plt_x && this.edited_cam.plt_w) {
          this.draw_rect(plates_color,
            Math.round(this.edited_cam.plt_x / this.image_width_coeff),
            Math.round(this.edited_cam.plt_y / this.image_height_coeff),
            Math.round(this.edited_cam.plt_w / this.image_width_coeff),
            Math.round(this.edited_cam.plt_h / this.image_height_coeff)
          )
        }
          var i = 0
          for (var line in this.edited_cam.lines) {
            this.edited_cam.lines[line]["color"] = i
            if (this.edited_cam.lines[line]["visible"] === true) {
              this.draw_line(lines_color[this.edited_cam.lines[line]["color"]],
                  Math.round(this.edited_cam.lines[line]["x"] / this.trasform_width_to_line_drawing),
                  Math.round(this.edited_cam.lines[line]["y"] / this.trasform_height_to_line_drawing),
                  Math.round(this.edited_cam.lines[line]["w"] / this.trasform_width_to_line_drawing),
                  Math.round(this.edited_cam.lines[line]["h"] / this.trasform_height_to_line_drawing)
              )
              if (this.edited_cam.lines[line]["direction"]["right"]) {
                let [new_x, new_y, new_x1, new_y1] = this.get_perpendicular_clockwise(
                    this.edited_cam.lines[line]["x"] / this.trasform_width_to_line_drawing,
                    this.edited_cam.lines[line]["y"] / this.trasform_height_to_line_drawing,
                    (this.edited_cam.lines[line]["x" ]/ this.trasform_width_to_line_drawing + this.edited_cam.lines[line]["w"]/ this.trasform_width_to_line_drawing) / 2,
                    (this.edited_cam.lines[line]["y"]/ this.trasform_height_to_line_drawing + this.edited_cam.lines[line]["h"]/ this.trasform_height_to_line_drawing) / 2
                )
                this.draw_arrow(lines_color[lines_color[this.edited_cam.lines[line]["color"]]],
                    new_x,
                    new_y,
                    new_x1,
                    new_y1
                )
              }
              if (this.edited_cam.lines[line]["direction"]["left"]) {
                let [new_x, new_y, new_x1, new_y1] = this.get_perpendicular_anticlockwise(
                    (this.edited_cam.lines[line]["x"]/this.trasform_width_to_line_drawing + this.edited_cam.lines[line]["w"]/this.trasform_width_to_line_drawing) / 2,
                    (this.edited_cam.lines[line]["y"]/this.trasform_height_to_line_drawing + this.edited_cam.lines[line]["h"]/this.trasform_height_to_line_drawing) / 2,
                    this.edited_cam.lines[line]["x"] / this.trasform_width_to_line_drawing,
                    this.edited_cam.lines[line]["y"] / this.trasform_height_to_line_drawing,


                )
                this.draw_arrow(lines_color[this.edited_cam.lines[line]["color"]],
                    new_x,
                    new_y,
                    new_x1,
                    new_y1
                )
              }
             this.draw_text(lines_color[this.edited_cam.lines[line]["color"]],
                ((this.edited_cam.lines[line]["x"]/ this.trasform_width_to_line_drawing + this.edited_cam.lines[line]["w"]/ this.trasform_width_to_line_drawing) / 2),
                ((this.edited_cam.lines[line]["y"]/ this.trasform_height_to_line_drawing + this.edited_cam.lines[line]["h"]/ this.trasform_height_to_line_drawing) / 2),
                line
              )
            }
            i += 1
          }
      },
      finish_edit_line (i){
        for (let line in this.edited_cam.lines){
          if (this.edited_cam.lines[line]["index"] === i){
            delete this.edited_cam.lines.line
          }
        }
        let msg = {method: 'edit_cam_lines', params: {
            line: this.edited_line,
            ip: this.edited_cam.ip_address,
            port: this.edited_cam.port,
            username: this.edited_cam.username,
            password: this.edited_cam.password}}
        this.sendSocketMessage(msg)
        this.edited_line = ''
        this.draw_areas()
      },
      delete_line(line, i){
        this.edited_cam.lines[line]["visible"] = false
        this.edited_cam.lines[line] = {}
        this.items.splice(i,1)
        this.draw_areas()
      },
      add_arrow_left(line){
        if (this.edited_cam.lines[line]["visible"]) {
          this.edited_cam.lines[line]["direction"]["left"] = !this.edited_cam.lines[line]["direction"]["left"]
          if (this.edited_cam.lines[line]["direction"]["left"]) {
            let [new_x, new_y, new_x1, new_y1] = this.get_perpendicular_anticlockwise(
                ((this.edited_cam.lines[line]["x"] + this.edited_cam.lines[line]["w"]) / 2) / this.trasform_width_to_line_drawing,
                ((this.edited_cam.lines[line]["y"] + this.edited_cam.lines[line]["h"]) / 2) / this.trasform_height_to_line_drawing,
                this.edited_cam.lines[line]["x"] / this.trasform_width_to_line_drawing,
                this.edited_cam.lines[line]["y"] / this.trasform_height_to_line_drawing,
            )


            this.draw_arrow(this.edited_cam.lines[line]["color"],
                new_x,
                new_y,
                new_x1,
                new_y1
            )
          }
        }
        this.draw_areas()
      },
      add_arrow_right(line){
        if (this.edited_cam.lines[line]["visible"]) {
          this.edited_cam.lines[line]["direction"]["right"] = !this.edited_cam.lines[line]["direction"]["right"]
          if (this.edited_cam.lines[line]["direction"]["right"]){
            let [new_x, new_y, new_x1, new_y1] = this.get_perpendicular_clockwise(
                this.edited_cam.lines[line]["x"] / this.trasform_width_to_line_drawing,
                this.edited_cam.lines[line]["y"] / this.trasform_height_to_line_drawing,
                ((this.edited_cam.lines[line]["x"] + this.edited_cam.lines[line]["w"]) / 2) / this.trasform_width_to_line_drawing,
                ((this.edited_cam.lines[line]["y"] + this.edited_cam.lines[line]["h"]) / 2) / this.trasform_height_to_line_drawing
            )


            this.draw_arrow(this.edited_cam.lines[line]["color"],
                new_x,
                new_y,
                new_x1,
                new_y1
            )
          }
        }
        this.draw_areas()
      },
      open_line_editor: function (name, i){
        this.selected_area = 'line_drawing'
        for (let line in this.edited_cam.lines){
          if (this.edited_cam.lines[line]["index"] === i){
            this.edited_cam.lines[name] = this.edited_cam.lines[line];
          }
        }
        this.edited_line =  this.edited_cam.lines[name];
        this.edited_line["name"] = name
        if (this.edited_cam.lines[name] === undefined) {
          this.edited_cam.lines[name] = {}
          this.edited_cam.lines[name]["index"] = i
          this.edited_cam.lines[name]["visible"] = true
          this.edited_cam.lines[this.edited_line["name"]]["direction"] = {}
          this.edited_cam.lines[this.edited_line["name"]]["direction"]["right"] = false
          this.edited_cam.lines[this.edited_line["name"]]["direction"]["left"] = false
        }
      },
      edit_step_one: function () {
        this.step = 1
        this.stepper_card_width = this.small_window
      },
      edit_step_two: function () {
        if (!this.first_step_valid) return
        this.stepper_card_width = this.big_window
        this.step = 2
        this.send_cam_rtsp_link()
        if (this.edited_cam.cross_line_detection === true) {
          this.get_lines_from_cam()
        }
      },
      edit_step_three: function () {
        if (!this.second_step_valid) return
        this.stepper_card_width = this.big_window
        this.step = 3
        this.stop_sending_images()
        if (this.edited_cam.cross_line_detection === false) {
          this.edited_cam.first_line = []
          this.edited_cam.second_line = []
        }
      },
      send_cam_rtsp_link: function () {
        let msg = {method: 'show_cam_view', params: {cam_name: this.edited_cam.name, rtsp_link: this.edited_cam.rtsp_link}}
        this.sendSocketMessage(msg)
        this.view_interval_id = setInterval(() => {
        this.image.src = this.$http_hostname + `/static/images/${this.edited_cam.name}.png#${performance.now()}`
        this.image.onload = () => {
          this.cam_view_canvas.drawImage(this.image, 0, 0, this.image_params.view_w, this.image_params.view_h)
          }
        }, 1000)
      },
      get_lines_from_cam: function () {
        let msg = {
          method: 'request_cam_lines',
          params: {
            ip: this.edited_cam.ip_address,
            port: this.edited_cam.port,
            username: this.edited_cam.username,
            password: this.edited_cam.password,
          }
        }
        this.sendSocketMessage(msg)
      },
      save_cam: function () {
        if (!this.edited_cam.plt_h || !this.edited_cam.plt_w || !this.edited_cam.mtn_x || !this.edited_cam.mtn_w) {
          this.setSnackbar({
            text: i18n.t('notifications.cameras.working_areas_not_selected'),
          })
          return
        }
        [this.edited_cam.mtn_x, this.edited_cam.mtn_y, this.edited_cam.mtn_w, this.edited_cam.mtn_h] = this.corrected_coordinates(this.edited_cam.mtn_x, this.edited_cam.mtn_y, this.edited_cam.mtn_w, this.edited_cam.mtn_h);
        [this.edited_cam.plt_x, this.edited_cam.plt_y, this.edited_cam.plt_w, this.edited_cam.plt_h] = this.corrected_coordinates(this.edited_cam.plt_x, this.edited_cam.plt_y, this.edited_cam.plt_w, this.edited_cam.plt_h);
        this.step = 1
        let t = this
        let _edited_cam = this.edited_cam
        let data = {cam: this.edited_cam}
        if (this.edited_cam_index > -1) {
          let cam_index = this.edited_cam_index
          this.$http({url: this.$http_hostname + '/cameras_settings/edit', data: data, method: 'POST'})
          .then(() => {
            Object.assign(t.cams_data[cam_index], _edited_cam)
            t.setSnackbar({
              text: i18n.t('notifications.cameras.cam_edited', {cam_name: _edited_cam.name})
            })
            t.$emit('changes_applied')
          })
          .catch(error => {
            t.show_error_message(error)
          })
        } else {
          this.$http({url: this.$http_hostname + '/cameras_settings/add', data: data, method: 'POST'})
          .then(resp => {
            _edited_cam._id = resp.data.new_cam_id
            t.cams_data.push(_edited_cam)
            t.setSnackbar({
              text: i18n.t('notifications.cameras.cam_added', {cam_name: _edited_cam.name}),
            })
            t.$emit('changes_applied')
          })
          .catch(error => {
            t.show_error_message(error)
          })
        }
        this.close_editor()
      },
      drawing: function (e) {
          if (this.need_to_draw === true) {
            if (this.selected_area === 'plates_detect') {
              this.edited_cam.plt_w = Math.round((e.offsetX - this.edited_cam.plt_x/this.image_width_coeff)  * this.image_width_coeff)
              this.edited_cam.plt_h = Math.round((e.offsetY - this.edited_cam.plt_y/this.image_height_coeff) * this.image_height_coeff)
            }
            if (this.selected_area === 'motion_detect') {
              this.edited_cam.mtn_w = Math.round((e.offsetX - this.edited_cam.mtn_x/this.image_width_coeff)  * this.image_width_coeff)
              this.edited_cam.mtn_h = Math.round((e.offsetY - this.edited_cam.mtn_y/this.image_height_coeff) * this.image_height_coeff)

            }
            if (this.selected_area === 'line_drawing') {
              if( this.edited_cam.lines[this.edited_line["name"]]["visible"]) {
                this.edited_cam.lines[this.edited_line["name"]]["w"] = Math.round((e.offsetX * 2 - this.edited_cam.lines[this.edited_line["name"]]["x"] / this.trasform_width_to_line_drawing) * this.trasform_width_to_line_drawing)
                this.edited_cam.lines[this.edited_line["name"]]["h"] = Math.round((e.offsetY * 2 - this.edited_cam.lines[this.edited_line["name"]]["y"] / this.trasform_height_to_line_drawing) * this.trasform_height_to_line_drawing)
              }
            }
            this.draw_areas()
          }
      },
      draw_rect: function (color, x, y, w, h) {
        this.drawing_canvas.beginPath()
        this.drawing_canvas.rect(x, y, w, h)
        this.drawing_canvas.strokeStyle = color
        this.drawing_canvas.lineWidth = 3
        this.drawing_canvas.stroke()
      },
      draw_line: function (color, x, y, w, h) {
        this.drawing_canvas.beginPath()
        this.drawing_canvas.moveTo(x,y)
        this.drawing_canvas.lineTo(w,h)
        this.drawing_canvas.strokeStyle = color
        this.drawing_canvas.lineWidth = 3
        this.drawing_canvas.stroke()
        this.drawing_canvas.closePath()
      },
      draw_text: function (color,x,y, name){
          this.drawing_canvas.font = "30px Arial";
          this.drawing_canvas.fillStyle = color;
          this.drawing_canvas.fillText(name, x, y);
      },
      get_perpendicular_clockwise: function (x1,y1,x2,y2){
        var px = y1 - y2;
        var py = x2 - x1;
        const endLen = 30
        const len = endLen / Math.hypot(px, py)
        px *= len  // make leng 10 pixels
        py *= len
        var new_x1 = x2
        var new_y1 = y2
        var new_x2 = x2 - px
        var new_y2 = y2 - py
        return [new_x1,new_y1,new_x2,new_y2]
      },
      get_perpendicular_anticlockwise: function (x1,y1,x2,y2){
        var px = y1 - y2;
        var py = x2 - x1;
        const endLen = 30
        const len = endLen / Math.hypot(px, py)
        px *= len  // make leng 10 pixels
        py *= len
        var new_x1 = x1
        var new_y1 = y1
        var new_x2 = x1 - px
        var new_y2 = y1 - py
        return [new_x1,new_y1,new_x2,new_y2]
      },
      draw_arrow: function (color, fromx, fromy, tox, toy){
          var headlen = 10; // length of head in pixels
          var dx = tox - fromx
          var dy = toy - fromy
          var angle = Math.atan2(dy, dx)
          this.drawing_canvas.beginPath()
          this.drawing_canvas.lineWidth = 3
          this.drawing_canvas.strokeStyle = color
          this.drawing_canvas.moveTo(fromx, fromy)
          this.drawing_canvas.lineTo(tox, toy)
          this.drawing_canvas.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6))
          this.drawing_canvas.moveTo(tox, toy)
          this.drawing_canvas.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6))
          this.drawing_canvas.stroke()
          this.drawing_canvas.closePath()
      },
      start_finish_drawing: function (e) {
        if (!this.need_to_draw) {
          let x = Math.round(e.offsetX * this.image_width_coeff)
          let y = Math.round(e.offsetY * this.image_height_coeff)
          if (this.selected_area === 'plates_detect') {
            this.edited_cam.plt_x = x
            this.edited_cam.plt_y = y
          }
          if (this.selected_area === 'motion_detect') {
            this.edited_cam.mtn_x = x
            this.edited_cam.mtn_y = y
          }
          if (this.selected_area === 'line_drawing') {
            if( this.edited_cam.lines[this.edited_line["name"]]["visible"]) {
              let x = Math.round(e.offsetX * this.trasform_width_to_line_drawing)
              let y = Math.round(e.offsetY * this.trasform_height_to_line_drawing)
              this.edited_cam.lines[this.edited_line["name"]]['x'] = x
              this.edited_cam.lines[this.edited_line["name"]]['y'] = y
            }
          }
          this.need_to_draw = true
        }
        else {
            this.need_to_draw = false
        }
      },
      open_cam_editor: function (cam) {
        this.drawing_canvas.clearRect(0, 0, this.image_params.view_w, this.image_params.view_h)
        this.cam_edit_dialog = true
        if (!cam) {
          Object.assign({}, this.default_cam)
          return
        }
        if (cam.gate_id) {
          this.selected_checkpoint_id = this.gates.find(gate => gate._id['$oid'] === cam.gate_id['$oid']).checkpoint_id
        }
        this.edited_cam_index = this.cams_data.indexOf(cam)
        this.edited_cam = Object.assign({}, cam)
      },
      delete_cam: function (cam) {
        const cam_index = this.cams_data.indexOf(cam)
        let data = {'cam_id': cam._id}
        confirm(i18n.t('submissions.delete_cam', {cam_name: cam.name})) &&
        this.$http({url: this.$http_hostname + '/cameras_settings/delete_cam_by_id', data: data, method: 'DELETE'})
        .then(() => {
          this.cams_data.splice(cam_index, 1)
          this.setSnackbar({
            text: i18n.t('notifications.cameras.cam_deleted', {cam_name: cam.name})
            // text: `Камера ${cam.name} удалена`,
          })
          this.$emit('changes_applied')
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
      close_editor: function() {
        this.step = 1
        this.selected_area = 'plates_detect'
        this.cam_edit_dialog = false
        this.edited_cam = Object.assign({}, this.default_cam)
        this.edited_cam_index = -1
        this.selected_checkpoint_id = ''
        this.stop_sending_images()
      },
      cam_gate_and_checkpoint_names: function (cam) {
        let text_none = i18n.t('general.none')
        if (cam.gate_id) {
          let gate = this.gates.find(gate => gate._id['$oid'] === cam.gate_id['$oid'])
            if (gate.checkpoint_id) {
              let checkpoint = this.checkpoints.find(chp => chp._id['$oid'] === gate.checkpoint_id['$oid'])
              return {gate_name: gate.name, checkpoint_name: checkpoint.name}
            } else {
              return {gate_name: gate.name, checkpoint_name: text_none}
            }
        } else {
          return {gate_name: text_none, checkpoint_name: text_none}
        }
      },
      stop_sending_images: function () {
        //this.$socket.send(JSON.stringify({'method': 'stop_showing_cam_view', 'params': ''}))
        let msg = {'method': 'stop_showing_cam_view', 'params': ''}
        this.sendSocketMessage(msg)
        clearInterval(this.view_interval_id)
      },
      areas_checkbox_title: function (rect_name) {
        let area_name = ''
        let area_status = ''
        let text_selected = `(${i18n.t('pages.devices.cameras.dialog.selected')})`
        let text_not_selected = `(${i18n.t('pages.devices.cameras.dialog.not_selected')})`
        if (rect_name === 'plates_detect') {
          area_name = i18n.t('pages.devices.cameras.dialog.plates_detection_area');
          (this.edited_cam.plt_x && this.edited_cam.plt_w) ? area_status = text_selected : area_status = text_not_selected
        }
        else if (rect_name === 'motion_detect') {
          area_name = i18n.t('pages.devices.cameras.dialog.motion_detection_area');
          (this.edited_cam.mtn_x && this.edited_cam.mtn_w) ? area_status = text_selected : area_status = text_not_selected
        }
        return `${area_name} ${area_status}`
      },
      corrected_coordinates: function (x, y, w, h) {
        if (w < 0) {
          x = x + w
          w = -w
        }
        if (h < 0) {
          y = y + h
          h = -h
        }
        return [x, y, w, h]
      },
      correct_line_values: function (w,h){
        if(w < 0) {
          w = 0
        }
        if (w > this.image_params.width_lines){
          w = this.image_params.width_lines
        }
        if (h < 0){
          h = 0
        }
        if (h < this.image_params.height_lines){
          h = this.image_params.height_lines
        }
        return [w, h]
      },
      ip_from_rtsp_link: function (){

        try {
            let parsed_string = this.edited_cam.rtsp_link.split('.')
            this.edited_cam.ip_address = parsed_string[0].slice(-3) + '.' + parsed_string[1] + '.' + parsed_string[2] + '.' + parsed_string[3].slice(0, 3)
        }
        catch {
          this.edited_cam.ip_address = ''
        }
      },
      username_from_rtsp_link: function (){
        try {
          let parsed_string = this.edited_cam.rtsp_link.split(':')
          this.edited_cam.username = parsed_string[1].replace('//', '')
        }
        catch {
          this.edited_cam.username = ''
        }
      },
      password_from_rtsp_link: function (){
        try {
          let parsed_string = this.edited_cam.rtsp_link.split(':')
          parsed_string = parsed_string[2].split('@')
          this.edited_cam.password = parsed_string[0]
        }
        catch {
          this.edited_cam.password= ''
        }
      },
      is_line_readonly: function (i){
        return this.edited_line["index"] === i
      },
      ...mapActions(['setSnackbar', 'sendSocketMessage'])
    },

    computed: {
      rules(){
        const rules = []
         if (this.edited_cam.cross_line_detection) {
          const rule =
            v => !!v || i18n.t('validation.this_field_is_required')
          rules.push(rule)
        }
        return rules
      },
      form_title: function () {
        let text_add_cam = i18n.t('pages.devices.cameras.dialog.add_cam')
        let text_edit_cam = i18n.t('pages.devices.cameras.dialog.edit_cam')
        return this.edited_cam_index === -1? text_add_cam : text_edit_cam
      },
      lines_in_cam: function (){
        let lines_list = []
        this.cam_lines.forEach(line => {
          lines_list.push(line)
        })
        return lines_list
      },
      trasform_width_to_line_drawing: function () {
        return this.image_params.width_lines / this.image_params.view_w
      },
      trasform_height_to_line_drawing: function () {
        return this.image_params.height_lines / this.image_params.view_h
      },

      gates_in_selected_checkpoint: function () {
        let gates_in_checkpoint = []
        if (this.selected_checkpoint_id) {
          this.gates.forEach(gate => {
            if (gate.checkpoint_id && gate.checkpoint_id['$oid'] === this.selected_checkpoint_id['$oid']) {
              gates_in_checkpoint.push(gate)
            }
          })
        } else {
          gates_in_checkpoint = this.gates
        }
        return gates_in_checkpoint
      },
      image_width_coeff: function () {
        return this.image_params.real_w / this.image_params.view_w
      },
      image_height_coeff: function () {
        return this.image_params.real_h / this.image_params.view_h
      },
      motion_detection_rate_range: function () {
        return {
          min: 1,
          max: this.edited_cam.frame_rate
        }
      },
      first_step_valid: function () {
        return  this.$refs.first_step_valid.validate()
      },
      second_step_valid: function () {
        return  this.$refs.second_step_valid.validate()
      },
      motion_detection_state_str: function () {
        if (this.edited_cam.motion_detection) {
          return i18n.t('pages.devices.cameras.dialog.motion_detection_is_on')
        } else {
          return i18n.t('pages.devices.cameras.dialog.motion_detection_is_off')
        }
      },
      cross_line_detection_state_str: function () {
        if (this.edited_cam.cross_line_detection) {
          return i18n.t('pages.devices.cameras.dialog.cross_line_detection_is_on')
        } else {
          return i18n.t('pages.devices.cameras.dialog.cross_line_detection_is_off')
        }
      },

      cross_line_timeout_str: function () {
        if (this.edited_cam.cross_line_timeout_enabled) {
          return i18n.t('pages.devices.cameras.dialog.cross_line_timeout_is_on')
        } else {
          return i18n.t('pages.devices.cameras.dialog.cross_line_timeout_is_off')
        }
      }
    },
    watch: {
      cam_edit_dialog (val) {
        this.$refs.first_step_valid.resetValidation()
        this.$refs.second_step_valid.resetValidation()
        // !val && this.stop_sending_images()
        !val && this.close_editor()
        this.edit_step_one()
      },
      // eslint-disable-next-line no-unused-vars
      selected_area (val) {
        this.draw_areas()
      },
    },
    mounted() {
      let canv_drawing = document.getElementById('drawing_canvas')
      let canv_cam_view = document.getElementById('covering_canvas')
      this.drawing_canvas = canv_drawing.getContext('2d')
      this.cam_view_canvas = canv_cam_view.getContext('2d')

      this.drawing_canvas.width = this.drawing_canvas.canvas.offsetWidth
      this.drawing_canvas.height = this.drawing_canvas.canvas.offsetHeight
      this.image = new Image()

    },
    beforeDestroy() {
      this.stop_sending_images()
    }
}
</script>

<style lang="scss">
.cams_step_one_buttons {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
}
.exit-button {
  width: 170px;
}
.save-button {
  width: 170px;
}

.outside-wrapper {
    border:1px solid #d0d0d0;
    margin: auto;
    border-radius: 3px;
}
.inside-wrapper {
    width:100%; height:100%;
    position:relative;
    border-radius: 3px;
}
.covered-image {
    width:100%; height:100%;
    position:absolute; top:0; left:0;
    border-radius: 3px;
}
.drawing-canvas {
    position:absolute; top:0; left:0;
    background-color: rgba(35, 126, 148, 0.1);
    border-radius: 3px;
}
.loading-circular {
  position: absolute;
  text-align: center;
  margin-top: calc(202px - 35px);
  left: 0;
  right: 0;
}
.height-textfield {
  height: 56px;
}
.margin-t {
  margin-top: 15px;
}
.slider {
  width: 550px;
}

.cam_settings_action_width {
  min-width: 300px;
}
.add_line_button {
  justify-content: left;
}
</style>